import { abbreviate } from "../utils/utils";
import { connect } from 'react-redux';
import Messages from "./messages";
import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { selectChat } from "../../redux/chatSlice";
import { Button } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import ChatService from '../../services/chatservice';
import "../../css/chat/chatwindow.css";
import { addMessage } from "../../redux/chatSlice";
import useMonitorAPIService from "../../services/monitorapiservice";
import { statusColors } from "../utils/consts";

function ChatWindow(props) {

    const { t } = useTranslation();
    const { getUserStatus } = useMonitorAPIService();
    const messagesRefs = useRef([]);
    const lastMessageRef = useRef(null);
    const divContent = useRef([]);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("loggedout");

    useEffect(() => {
        scrollToBottom()
        divContent.current.focus();
        let interlocutorPin = "";
        interlocutorPin = props.chat.to === `${props.id}M` ? props.chat.from : props.chat.to;
        interlocutorPin = interlocutorPin.toString().replaceAll("M", "");
        getUserStatus(props.token, interlocutorPin, (resStatus) => {
            if (resStatus.data) {
                setStatus(resStatus.data.toLowerCase());
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.chat]);


    const scrollToBottom = () => {
        lastMessageRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    const keyDown = e => {
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    }

    const sendMessage = () => {
        let internalMessage = {
            id: props.chat.id,
            url: "",
            text: message,
            pin: props.id + "M",
            from: props.id + "M",
            media: false,
            mediaType: "text",
            mid: props.chat.messages.length,
            name: props.name,
            date: new Date()
        };
        ChatService.sendMessage(internalMessage, res => {
            if (res.data) {
                props.addMessage(internalMessage);
                setMessage("");
                divContent.current.textContent = "";
            }
        });
    }

    const closeChat = () => {
        ChatService.closeChat(props.chat.id);
        props.selectChat(null)
    }

    return (
        props.chat &&
        <div className="card w-100 rounded-0 border-0">
            <div className="card-header pe-5">
                <div className="card-title">
                    <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={e => props.selectChat(null)}>
                        <FontAwesomeIcon size="lg" icon={duotone("arrow-left")} />
                    </button>
                    <div className="symbol symbol-50px me-3">

                        {
                            (!props.chat.image) &&
                            <div className='user-img text-primary bg-light-primary'>{abbreviate(props.chat.fullname)}</div>
                        }

                        {
                            (props.chat.image) &&
                            <img src={`${props.chat.image}`} alt="agent" />
                        }
                    </div>
                    <div className="d-flex justify-content-center flex-column me-3">
                        <div className="fs-7 text-dark fw-bold w-100">{props.chat.fullname} </div>
                        <div className="mb-0 lh-1">
                            <span className={"badge badge-" + statusColors[status] + " badge-circle w-10px h-10px me-1"}></span>
                            <span className="fs-7 fw-semibold text-muted">{t(status)}</span>
                        </div>
                    </div>
                </div>
                <div className="card-toolbar">
                    <div className="me-2">
                        <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={closeChat}>
                            <FontAwesomeIcon size="lg" icon={duotone("circle-xmark")} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="card-body" style={{ height: "64vh", overflow: "auto" }}>
                <Messages chat={props.chat} messagesRefs={messagesRefs} supervisorId={props.id} lastMessage={lastMessageRef}></Messages>
            </div>
            <div className="card-footer pt-4" >
                <div placeholder={t("writeamessage")} ref={divContent} onInput={e => { setMessage(e.target.textContent) }} onKeyDown={keyDown}
                    contentEditable={true} className='inputtext position-relative top-0 start-0' type="text" suppressContentEditableWarning={true}
                ></div>
                <Button variant="primary" size="sm" className="float-end" onClick={sendMessage}>{t("send")}</Button>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        name: state.supervisor.fullname,
        id: state.supervisor.id,
        chats: state.chat.chats,
        chat: state.chat.selectedChat
    };
};


export default connect(mapStateToProps, { selectChat, addMessage })(ChatWindow);